import React, { useEffect } from 'react';
import { useServiceUrls, useSettings } from '../../hooks/queryHooks';
import { useHistory } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import '../../hooks/zustandHooks';
import Loader from '../loader/Loader';
import { initApplication, initQueries } from '../../hooks/utils';
import { useTranslation } from 'react-i18next';
import { trackEvent } from '../../App';
import { EventTypes } from '../../utils/applicationInsights';
import { useAppState } from '../../hooks/zustandHooks';

const InitialScreen = () => {
  const { serviceUrls, isServiceUrlsError } = useServiceUrls();
  const { settings, isSettingsError } = useSettings();
  const history = useHistory();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { useValidationToken, reAuthentication, isReconfirmation, consentRevokeSuccess, rpName, state } = useAppState(
    state => state.appState
  );

  if (isSettingsError || isServiceUrlsError) {
    history.push('/error');
  }

  useEffect(() => {
    initApplication(history);

    if (serviceUrls && settings) {
      initQueries(queryClient, serviceUrls, history, settings);
      trackEvent({
        type: EventTypes.INIT_STATE_SUCCESS,
        payload: {
          useValidationToken,
          reAuthentication,
          isReconfirmation,
          consentRevokeSuccess,
          rpName: rpName || settings?.customerName,
          providerAuthStatus: state?.ProviderAuthStatus
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(serviceUrls || {}).length, Object.keys(settings || {}).length]);

  return <Loader display={true} spinnerText={t('Loading...')} />;
};

export default InitialScreen;
